module.exports = __webpack_public_path__ + "static/img/xbq1009.13ddd85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xbq1009.jpg
// module id = AKNx
// module chunks = 0